import type { ErrorComponentProps } from "@tanstack/react-router";
import ErrorState from "./flow/ErrorState";

/**
 * What the student sees when a screen throws — the router's defaultErrorComponent
 * (router.tsx). It stands in for TanStack's built-in error box, which prints the
 * raw message and stack: fine for us in dev, but never something a student should
 * meet. Here it is the same friendly ErrorState the rest of Lume uses — the sad
 * CircleBuddy leads and offers to try again (reset re-renders the route).
 *
 * The `.lume-page` scope flips the semantic tokens under the dark theme (like the
 * embedded NotFound), so the text is not dark-on-dark when this lands inside the
 * caderno shell; it paints no background of its own, so the shell shows through.
 */
export default function RouteError({ error, reset }: ErrorComponentProps) {
  return (
    <div className="lume-page grid min-h-[60vh] place-items-center px-6 py-10 text-ink">
      <ErrorState error={error} onRetry={reset} />
    </div>
  );
}
